exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myFormDrawer .el-drawer__header {\n  margin-bottom: 0.625rem;\n  padding-bottom: 0.75rem;\n  color: #333;\n  border-bottom: 0.0625rem solid #e8e8e8;\n}", ""]);

// exports
